import React, { useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import { get } from "api/axios"
import endpoints from "api/endpoints"

const BarChart = () => {
  const [data, setData] = useState([])

  const getData = async () => {
    try {
      const resp = await get(`${endpoints.usersStats}/weeklylogs`)
      if (resp?.data?.success) {
        setData(resp.data.data)
      }
    } catch (error) {
      console.error("Error fetching weekly logs:", error)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    console.log("Updated Data: ", data)
  }, [data])

  const options = {
    chart: { toolbar: { show: false } },
    plotOptions: { bar: { horizontal: false, borderRadius: 8 } },
    dataLabels: { enabled: false },
    colors: ["#34c38f"],
    grid: { borderColor: "#f1f1f1", yaxis: { lines: { show: false } } },
    yaxis: {
      min: 0,
      max: 10,
      tickAmount: 1,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    xaxis: {
      categories: data.map(item =>
        new Date(item.date).toLocaleString("en-US", { weekday: "short" })
      ),
    },
    tooltip: {
      y: {
        title: {
          formatter: () => "User Count",
        },
      },
    },
  }

  return (
    <>
      {data.length > 0 && (
        <ReactApexChart
          options={options}
          series={[{ data: data.map(item => item.count) }]}
          type="bar"
          width="100%"
          height={315}
        />
      )}
    </>
  )
}

export default BarChart
